import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "prompt"
};
const _hoisted_2 = {
  class: "hot-words"
};
const _hoisted_3 = {
  class: "model"
};
const _hoisted_4 = {
  class: "model-font"
};
const _hoisted_5 = {
  class: "image-style"
};
const _hoisted_6 = {
  class: "style-font"
};
const _hoisted_7 = {
  class: "image-size"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "size-font"
};
const _hoisted_10 = {
  class: "btns"
};
import { ImageApi } from '@/api/ai/image';
import { Dall3Models, Dall3StyleList, ImageHotWords, Dall3SizeList, AiPlatformEnum } from '@/views/aip/utils/constants';
import { ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    models: {
      type: Array,
      default: () => []
    }
  },
  emits: ['onDrawStart', 'onDrawComplete'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    // 接收父组件传入的模型列表
    const props = __props;
    const emits = __emit; // 定义 emits
    // 定义属性
    const prompt = ref(''); // 提示词
    const drawIn = ref(false); // 生成中
    const selectHotWord = ref(''); // 选中的热词
    const selectModel = ref('dall-e-3'); // 模型
    const selectSize = ref('1024x1024'); // 选中 size
    const style = ref('vivid'); // style 样式
    /** 选择热词 */
    const handleHotWordClick = async hotWord => {
      // 情况一：取消选中
      if (selectHotWord.value == hotWord) {
        selectHotWord.value = '';
        return;
      }
      // 情况二：选中
      selectHotWord.value = hotWord;
      prompt.value = hotWord;
    };
    /** 选择 model 模型 */
    const handleModelClick = async model => {
      selectModel.value = model.key;
      // 可以在这里添加模型特定的处理逻辑
      // 例如，如果未来需要根据不同模型设置不同参数
      if (model.key === 'dall-e-3') {
        // DALL-E-3 模型特定的处理
        style.value = 'vivid'; // 默认设置vivid风格
      } else if (model.key === 'dall-e-2') {
        // DALL-E-2 模型特定的处理
        style.value = 'natural'; // 如果有其他DALL-E-2适合的默认风格
      }
      // 更新其他相关参数
      // 例如可以默认选择最适合当前模型的尺寸
      const recommendedSize = Dall3SizeList.find(size => model.key === 'dall-e-3' && size.key === '1024x1024' || model.key === 'dall-e-2' && size.key === '512x512');
      if (recommendedSize) {
        selectSize.value = recommendedSize.key;
      }
    };
    /** 选择 style 样式  */
    const handleStyleClick = async imageStyle => {
      style.value = imageStyle.key;
    };
    /** 选择 size 大小  */
    const handleSizeClick = async imageSize => {
      selectSize.value = imageSize.key;
    };
    /**  图片生产  */
    const handleGenerateImage = async () => {
      // 从 models 中查找匹配的模型
      const matchedModel = props.models.find(item => item.model === selectModel.value && item.platform === AiPlatformEnum.OPENAI);
      if (!matchedModel) {
        message.error('该模型不可用，请选择其它模型');
        return;
      }
      // 二次确认
      await message.confirm(`确认生成内容?`);
      try {
        // 加载中
        drawIn.value = true;
        // 回调
        emits('onDrawStart', AiPlatformEnum.OPENAI);
        const imageSize = Dall3SizeList.find(item => item.key === selectSize.value);
        const form = {
          platform: AiPlatformEnum.OPENAI,
          prompt: prompt.value,
          // 提示词
          modelId: matchedModel.id,
          // 使用匹配到的模型
          style: style.value,
          // 图像生成的风格
          width: imageSize.width,
          // size 不能为空
          height: imageSize.height,
          // size 不能为空
          options: {
            style: style.value // 图像生成的风格
          }
        };
        // 发送请求
        await ImageApi.drawImage(form);
      } finally {
        // 回调
        emits('onDrawComplete', AiPlatformEnum.OPENAI);
        // 加载结束
        drawIn.value = false;
      }
    };
    /** 填充值 */
    const settingValues = async detail => {
      prompt.value = detail.prompt;
      selectModel.value = detail.model;
      style.value = detail.options?.style;
      const imageSize = Dall3SizeList.find(item => item.key === `${detail.width}x${detail.height}`);
      await handleSizeClick(imageSize);
    };
    /** 暴露组件方法 */
    __expose({
      settingValues
    });
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("画面描述")])),
        _: 1
      }), _createVNode(_component_el_text, {
        tag: "p"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("建议使用\"形容词 + 动词 + 风格\"的格式，使用\"，\"隔开")])),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: prompt.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prompt.value = $event),
        maxlength: "1024",
        rows: 5,
        class: "w-100% mt-15px",
        "input-style": "border-radius: 7px;",
        placeholder: "例如：童话里的小屋应该是什么样子？",
        "show-word-limit": "",
        type: "textarea"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("随机热词")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "word-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ImageHotWords), hotWord => {
          return _openBlock(), _createBlock(_component_el_button, {
            round: "",
            class: "btn",
            type: selectHotWord.value === hotWord ? 'primary' : 'default',
            key: hotWord,
            onClick: $event => handleHotWordClick(hotWord)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(hotWord), 1)]),
            _: 2
          }, 1032, ["type", "onClick"]);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("模型选择")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "model-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Dall3Models), model => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(selectModel.value === model.key ? 'modal-item selectModel' : 'modal-item'),
            key: model.key
          }, [_createVNode(_component_el_image, {
            src: model.image,
            fit: "contain",
            onClick: $event => handleModelClick(model)
          }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_4, _toDisplayString(model.name), 1)], 2);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("风格选择")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "image-style-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Dall3StyleList), imageStyle => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(style.value === imageStyle.key ? 'image-style-item selectImageStyle' : 'image-style-item'),
            key: imageStyle.key
          }, [_createVNode(_component_el_image, {
            src: imageStyle.image,
            fit: "contain",
            onClick: $event => handleStyleClick(imageStyle)
          }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_6, _toDisplayString(imageStyle.name), 1)], 2);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("画面比例")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "size-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Dall3SizeList), imageSize => {
          return _openBlock(), _createElementBlock("div", {
            class: "size-item",
            key: imageSize.key,
            onClick: $event => handleSizeClick(imageSize)
          }, [_createElementVNode("div", {
            class: _normalizeClass(selectSize.value === imageSize.key ? 'size-wrapper selectImageSize' : 'size-wrapper')
          }, [_createElementVNode("div", {
            style: _normalizeStyle(imageSize.style)
          }, null, 4)], 2), _createElementVNode("div", _hoisted_9, _toDisplayString(imageSize.name), 1)], 8, _hoisted_8);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        round: "",
        loading: drawIn.value,
        disabled: prompt.value.length === 0,
        onClick: handleGenerateImage
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(drawIn.value ? '生成中' : '生成内容'), 1)]),
        _: 1
      }, 8, ["loading", "disabled"])])], 64);
    };
  }
});